import React from 'react';
import { WindowsIcon, AndroidIcon, AppleIcon, LinuxIcon, DisplayIcon } from '../icons';

const DeviceIcon = ({ device }) => {
  if (device === 'windows') return <WindowsIcon size={18} color="#1DA4F3" />;
  if (device === 'android') return <AndroidIcon size={18} color="#86B93E" />;
  if (device === 'apple') return <AppleIcon size={18} className="text-[#121212] dark:text-[#D0D0D0]" />;
  if (device === 'linux') return <LinuxIcon size={18} className="text-[#7B7B7B] dark:text-[#848484]" />;
  return <DisplayIcon size={18} className="text-[#7B7B7B] dark:text-[#848484]" />;
};

const ItemActions = ({ actions }) => (
  <div className="flex items-center space-x-2 relative">
    {actions.map(({ key, icon: Icon, onClick, ariaLabel, ariaPressed }) => (
      <button
        key={key}
        onClick={(e) => { e.stopPropagation(); onClick(); }}
        aria-label={ariaLabel}
        aria-pressed={ariaPressed}
        className="w-8 h-8 rounded-lg flex items-center justify-center transition-all duration-200 hover:bg-[#F1F1F1] dark:hover:bg-[#2A2A2A] hover:opacity-100 opacity-70"
      >
        <Icon size={16} className="text-[#7B7B7B] dark:text-[#848484]" />
      </button>
    ))}
  </div>
);

const SelectionCheckbox = ({ isSelected }) => (
  <div
    className="absolute bottom-3 right-3 z-10 w-6 h-6 rounded-lg flex items-center justify-center p-[3px] transition-all duration-200 bg-[#F2F2F2] dark:bg-[#2A2A2A]"
    style={{ boxShadow: 'inset 0 0.75px 1.5px rgba(50, 50, 50, 0.10)' }}
  >
    <div
      className={`w-full h-full rounded-[6px] transition-all duration-200 ${
        isSelected ? 'bg-[#7B7B7B] dark:bg-[#848484]' : 'bg-transparent'
      }`}
    />
  </div>
);

const ItemCard = ({
  children,
  date,
  device,
  actions = [],
  onClick,
  pinned = false,
  isSelecting = false,
  isSelected = false,
  onToggleSelect,
  className = '',
  ...props
}) => {
  const handleClick = isSelecting ? (e) => { e.stopPropagation(); onToggleSelect?.(); } : onClick;

  const selectionBorder = isSelecting && isSelected
    ? 'border border-[#ECECEC] dark:border-[#202020] outline outline-1 outline-[#ECECEC] dark:outline-[#202020]'
    : 'border border-[#ECECEC] dark:border-[#202020]';

  return (
    <div
      {...props}
      onClick={handleClick}
      className={`w-full max-w-[340px] h-[156px] bg-[#FCFCFC] dark:bg-[#1A1A1A] border ${selectionBorder} rounded-3xl transition-shadow duration-200 hover:shadow-xl cursor-pointer relative ${className}`}
    >
      <div className="w-[calc(100%-1rem)] h-[100px] m-2 bg-[#FFFFFF] dark:bg-[#121212] rounded-2xl relative overflow-hidden">
        {children}
      </div>

      <div className="px-4 pb-2 flex items-center justify-between">
        <div className="flex items-center">
          <div className="w-8 h-8 rounded-lg flex items-center justify-center">
            <DeviceIcon device={device} />
          </div>
          <div className="text-xs font-medium text-[#7B7B7B] dark:text-[#848484]">
            {date}
          </div>
        </div>
        {!isSelecting && <ItemActions actions={actions} />}
      </div>

      {isSelecting && <SelectionCheckbox isSelected={isSelected} />}
    </div>
  );
};

export default ItemCard;
